import React, { useState, useMemo, useEffect } from "react";
import _ from "lodash";
import HistoricalData from "./HistoricalData";
import "./styles.css"
import { groupServerData, setStyleToColumns, setCookie, getReportColumns, RelevantIcon } from "../oro-module/commonFunctions";
import { currencyToNumber, controls } from "../../pages/controls";
import { ToggleCustom } from "../FormComponents";
import { createComponent } from "../FormArea/FormContent";
import chroma from 'chroma-js';
import NoResults from "../../images/search.png";
import NotFound from "../../images/not-found.png";
import Glass from "../../images/glass.png";

import SearchingSVG from "../../images/search-oro.svg";

// import Snap from "snapsvg";


const ChartSettings = ({ chartType, props, handleBack }) => {
  // Show the settings required to manipulate the chart.
  // Start with column/row. * VALUE Column / row. Pivot -> start with column/row.
  let {
    currentPage,
    formElements,
    OriginalData,
    pieSliceClicked
  } = props.parentState;
  let { history } = formElements[currentPage];
  let { charts } = history;
  // Save all of these to parentState.
  let [rowWise, setRowWise] = useState(true);
  let [showVar2, setShowVar2] = useState(false);
  let [isDrillDown, setDrillDown] = useState(false);
  let [valField, setValField] = useState(false);



  const convertToPieChartData = ({ combinedData, history, level = 1, parentData = {} }) => {

    let retdata = [];
    let { targetfield, flabel } = charts['pie']['row'];

    let lst = combinedData[combinedData.length - 1];
    let totval = 0;
    if (level == 1) {
      if (lst['skip_rows'] == 'grand_total') { totval = currencyToNumber(lst[targetfield]) };
    } else {
      totval = currencyToNumber(parentData[targetfield]);
    }

    for (var i = 0; i < combinedData.length; i++) {
      let cd = combinedData[i];
      if (cd['skip_rows'] != 'grand_total') {
        let slicedata = {};
        let curval = currencyToNumber(cd[targetfield]);
        slicedata['value'] = curval;
        slicedata['label'] = cd[flabel];
        slicedata['rowdata'] = cd;
        // slicedata['index'] = i;
        // if (cd.subRows) {
        //   slicedata['drilldown'] = setClicked;
        // }
        // slicedata['padAngle'] = 0.01;

        // slicedata['startAngle'] = toAngle(Math.min(startAngle, 360));
        // slicedata['endAngle'] = toAngle(Math.min(startAngle + angleArea, 360));
        // startAngle += angleArea;

        if (cd.subRows) {
          slicedata['subRows'] = convertToPieChartData({ combinedData: cd.subRows, history, level: level + 1, parentData: cd });
        }
        retdata.push(slicedata);
      }
    }
    return retdata;
  }


  const generatePieChartData = ({ history, serverData, current }) => {
    let combinedData = groupServerData({ serverData, history, current });
    let chartData = convertToPieChartData({ combinedData, history });
    let colors = [...Array(100).keys()].map(r => chroma.random());

    return { chartData, colors };
  }

  let chartingData = useMemo(() => generatePieChartData({ serverData: OriginalData, current: { props }, history }), [chartType, rowWise, OriginalData, pieSliceClicked]);

  let allc = [
    ...controls.piechart({ width: "col-sm-12", dims: { cw: 25, ch: 25 }, data: chartingData }),
  ]

  const handleRowWise = () => {
    setRowWise(!rowWise);
  }

  return (
    <div className="row">
      <div className="col-sm-12" > <span className="hand" onClick={() => handleBack()}><RelevantIcon icon="back-arrow" style={{ fontSize: 20, color: "red" }} /></span></div>

      {chartType == 'pie' &&
        <div className="row" style={{ padding: "0px 10px" }}>
          <div className="col-sm-6">
            <ToggleCustom isChecked={rowWise} display={rowWise ? "Row" : "Column"} setChecked={handleRowWise} />
          </div>
          <div className="col-sm-6">
            <ToggleCustom isChecked={showVar2} display={showVar2 ? "Nested" : "Simple"} setChecked={() => setShowVar2(!showVar2)} />
          </div>
          <div className="col-sm-6">
            <ToggleCustom isChecked={isDrillDown} display={isDrillDown ? "Drilldown" : "Fixed"} setChecked={() => setDrillDown(!isDrillDown)} />
          </div>
          {createComponent({ allc, selectedFormTab: "", current: { props } })}
        </div>
      }
    </div>
  )
}

const ChartsList = ({ handleSelect }) => {

  let chartOptions = [
    { id: 'pie', label: "Pie", icon: "piechart-color", desc: "" },
    { id: 'bar', label: "Bar", icon: "bar-chart", desc: "" },
    { id: 'line', label: "Line", icon: "stock-chart", desc: "" },
    { id: 'area', label: "Area", icon: "area-chart", desc: "" },
    { id: 'scatter', label: "Scatter", icon: "scatter-plot", desc: "" },
    { id: 'surface', label: "Surface", icon: "surface-chart", desc: "" },
    { id: 'doughnut', label: "Doughnut", icon: "doughnut-chart", desc: "" },
    { id: 'bubble', label: "Bubble", icon: "bubble-chart", desc: "" },
    { id: 'radar', label: "Radar", icon: "radar-chart", desc: "" },
    { id: 'candle', label: "Candle", icon: "candle-plot", desc: "" },
    { id: 'gantt', label: "Gantt", icon: "gantt-chart", desc: "", style: { height: 50, marginBottom: 8 } },
  ];

  return (
    <div className="row">
      <div className="col-sm-12" style={{ textAlign: 'center', color: "gray" }}>Select chart</div>
      {chartOptions.map(({ id, icon, label, style }, idx) =>
        <div key={idx} className={`col-sm-4 `} style={{ textAlign: "center", marginBottom: 20 }}>
          <div className="chart-icon-container">
            <div className="hand" onClick={() => handleSelect(id)}>
              <RelevantIcon icon={icon} style={{ color: "#3282b8", fontSize: 50, ...style }} />
            </div>
            <div className="hand" style={{ color: "gray" }}>
              {label}
            </div>
          </div>
        </div>
      )
      }
    </div>
  )
}


const ReportsArea = (props) => {
  let lgs = props.liftGlobalState;

  let { parentState } = props;
  let {
    currentPage,
    localpage,
    formElements,
    pageData,
    OriginalData,
    OriginalDataOther,
    clickedSlice,
    clickedSliceLast,
    LocalVars,
    themecolor,
    chartBoxOpen,
    showCharts,
    timeTaken,
    isSearching,
    startingPage,
    openControls,
    full_report
  } = parentState;

  let winht = window.screen.height;
  // let minHeight = winht - 215;
  let minHeight = full_report ? winht - 50 : winht - 215;
  let tableheight = minHeight - 40;

  if (openControls.length > 0) {
    currentPage = openControls[openControls.length - 1]['fastpath'];
    minHeight = winht - 215 - 90;
  }
  let serverData = OriginalData;
  if (openControls.length > 0) {
    serverData = openControls[openControls.length - 1]['data'] ? openControls[openControls.length - 1]['data'] : [];
  }

  let { history, report, form } = formElements[currentPage];
  var { sortable, groupBy, perPage, extraRows, displayColumns, clickable, fillcontrol, textReportProps, filterable } = history;

  let rate = pageData.currency_convert;
  // displayColumns = [{
  //   Header: "Sr",
  //   type: "autoinc",
  //   accessor: "srno",
  //   align: 'center',
  //   width: 30,
  // }].concat(displayColumns);
  let displayColumnsStyled = setStyleToColumns(displayColumns);
  let tableData = useMemo(() => groupServerData({ serverData, history, current: { props } }), [serverData, rate, currentPage, clickedSlice, clickedSliceLast]);
  // console.log({ tableData })


  let x;
  !themecolor ? themecolor = "default" : x = 0;

  let { ShowHistory, searchTime } = LocalVars;

  if (!filterable) { filterable = false; }
  if (!sortable) { sortable = false; }

  if (form && form.length > 0 && clickable != false) {
    clickable = true;

    filterable = sortable = true;
  }

  // This is needed because OriginalData is array of OBJECTS, even though [...] will clone array, the references to original objects will remain.
  displayColumns = displayColumnsStyled;

  let ReportsData = tableData;

  let r1;
  !report ? report = {} : r1 = 1;

  !groupBy ? groupBy = [] : r1 = 1;
  !displayColumns ? displayColumns = [] : r1 = 1;
  let allColumns = getReportColumns(displayColumns, []);
  setCookie('allColumns', JSON.stringify(allColumns).replace(/%/g, "%25"));


  const handleClick = (id) => {
    if (chartBoxOpen && chartBoxOpen == id) {
      lgs({ name: 'chartBoxOpen' }, false);
    } else {
      lgs({ name: 'chartBoxOpen' }, id);
    }
  }
  // console.log({ serverData, tableData, ReportsData });

  return (
    <div className="col-12">
      <div className={`form-section ${themecolor}-form-section`} style={{ minHeight }}>
        {(!timeTaken || isSearching) &&
          <div className="search-placeholder">
            <div className="no-results-container">
              <div style={{ backgroundImage: `url(${NoResults})` }} className="searching-icon-container">
                <img className={`search-glass ${isSearching ? 'searchglass-animation' : ''}`} src={Glass} />
              </div>
            </div>

            <div className="no-results-msg">No results yet...</div>
            <div className="no-results-desc">Enter search terms above and click the <span className="action-button-icon">button</span>.</div>
            <div className="no-results-desc">The results will be displayed here.</div>
          </div>
        }

        {!isSearching && timeTaken && serverData && serverData.length == 0 &&
          <div className="search-placeholder">
            <div className="no-results-container">
              <div style={{ backgroundImage: `url(${NoResults})` }} className="searching-icon-container">
                <img className={`not-found-icon`} src={NotFound} />
              </div>
            </div>

            <div className="no-results-msg">No results found...</div>
            <div className="no-results-desc">Try to broaden your search by using less filters.</div>
          </div>
        }

        {timeTaken &&
          <div className="row" style={{ paddingLeft: 15 }}>
            {showCharts && !chartBoxOpen &&
              <div className="charts-container">
                <ChartsList
                  handleSelect={handleClick}
                />
              </div>
            }

            {showCharts && chartBoxOpen &&
              <div className="charts-container">
                <ChartSettings handleBack={() => lgs({ name: 'chartBoxOpen' }, false)} chartType={chartBoxOpen} props={props} />
              </div>
            }

            <div className="report-container" style={{ width: showCharts ? '75%' : '100%' }}>
              <div className={`historytable ${ShowHistory === false ? "hidehistory" : ""}`}>
                {ReportsData.length > 0 &&
                  <HistoricalData ReportsData={ReportsData} current={{ props }} displayColumns={displayColumns} startingParams={{ pi: startingPage ? startingPage : 0, tableheight }} />
                }
              </div>
              {searchTime && serverData.length > 0 &&
                <div className="col-sm-12" style={{ marginTop: 10 }}>
                  <div style={{ fontSize: 10, fontFamily: "Courier" }}>
                    Fetched {serverData.length}  {serverData.length > 1 ? "records" : "record"} in total {searchTime} ms {timeTaken ? "(Server " + timeTaken + " ms)" : ""}. {pageData.currency_convert && serverData.length > 0 && `(Amounts in ${pageData.currency_convert ? pageData.currency_convert : "Rupees"}).`} 🌍 Print the report only when necessary.
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div >
  );
}
export default ReportsArea;
